import React, { Component }  from 'react'
import { connect } from 'react-redux'
import CommonTable from 'components/Table'

import { Column } from 'react-virtualized'
import Badge from 'components/Badge'
import TenantStatusIcon from './StatusIcon'
import {tenantsTable} from 'selectors/tenant'
import Numeral from 'numeral'
import calcTable from 'utils/calcTable'

import * as R from 'ramda'

let select = (state, props) => ({
	tenants: props.data!=undefined ? props.data : tenantsTable(state)
})

export class TenantTable extends Component{
	render(){
		let { props } = this;
		let cols = {
			tenant:{min: 180, avg: 300}
		  , balance: {min: 90, avg: 200}
		  , phoneNumber: {min:100, avg:250}
		  , email: {min:250, avg:350}
		  , attachComment:70
		}
		cols = calcTable(props.width || (window.innerWidth-60), cols)
		return(
			<CommonTable entity="tenant" showAll={props.showAll} data={props.tenants}>
				{cols.tenant &&
					<Column
						width={cols.tenant}
						label="tenant"
						dataKey="tenant"
					/>
				}
				{
					cols.balance &&
					<Column
						width={cols.balance}
						label="balance"
						dataKey="balance"
						cellRenderer={({ cellData }) => (
							<div >
								{"$ " + Numeral(cellData).format('0,0')}
							</div>
						)}
					/>
				}
				{cols.phoneNumber &&
					<Column
						width={cols.phoneNumber}
						label="phone"
						dataKey="phoneNumber"
						cellRenderer={({ cellData }) => (
							<div>
								{cellData}
							</div>
						)}
					/>
				}
				{cols.email &&
					<Column
						width={cols.email}
						label="email"
						dataKey="email"
					/>
				}
				{cols.attachComment &&
					<Column
						width={cols.attachComment/2}
						label={<i style={{fontSize:"22px"}} className="material-icons">attach_file</i>}
						dataKey='attachments'
						disableSort
						cellRenderer={({ rowData }) =>
							<Badge
								style={{position:"relative", top:"8px", left:"-8px"}}
								badgeContent={rowData.attachments ? rowData.attachments.length : "0"}
								primary={false}
								secondary={rowData.attachments ? !!rowData.attachments.length : false}
							/>
						}
					/>
				}
				{cols.attachComment &&
					<Column
						width={cols.attachComment/2}
						label={<i style={{fontSize:"22px"}} className="material-icons">comment</i>}
						dataKey='comments'
						disableSort
						cellRenderer={({ rowData }) =>
							<Badge
								style={{position:"relative", top:"8px", left:"-8px"}}
								badgeContent={rowData.comments ? rowData.comments.length : "0"}
								primary={false}
								secondary={rowData.comments ? !!rowData.comments.length : false}
							/>
						}
					/>
				}
			</CommonTable>
		)
	}
}
export default connect(select)(TenantTable)



// WEBPACK FOOTER //
// ./src/routes/manager/tenants/Table.js